import './CustomSafeImageRenderer.scss';

const CustomSafeImageRenderer = ({
  data = { props: { src: '' } },
  schema = { title: '' },
  path = [],
  onZoom = () => {},
}) => {
  const handleZoom = () => onZoom(data.props.src);

  const renderMedia = () => {
    return (
      <div className={`default-type-string depth-${path.length}`}>
        <strong className="default-type-string-title">{schema.title}</strong>{' '}
        <span className="default-type-string-value" onClick={handleZoom}>
          <img
            src={data.props.src}
            className="default-type-string-format-image-thumbnail"
          />
        </span>
      </div>
    );
  };

  return <div className="CustomSafeImageRenderer">{renderMedia()}</div>;
};
export default CustomSafeImageRenderer;
